import { Helmet } from 'react-helmet-async'
import { matchPath, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { PAGE_TITLE_MAP } from './page-title.map'
import { PageTitleMessages } from './page-title.messages'

export const PageTitle = () => {
  const { pathname } = useLocation()
  const intl = useIntl()

  const matchedDescriptor = Object.entries(PAGE_TITLE_MAP).find(([path]) =>
    matchPath(pathname, { path, exact: true }),
  )?.[1]

  const pageLabel = matchedDescriptor
    ? intl.formatMessage(matchedDescriptor)
    : intl.formatMessage(PageTitleMessages.home)

  const suffix = intl.formatMessage(PageTitleMessages.suffix)

  return (
    <Helmet>
      <title>{`${pageLabel} - ${suffix}`}</title>
    </Helmet>
  )
}
